import { useRouter } from 'next/router';

import { useSignTab } from '~/shared/hooks/useSignTab';

export const useSignUpPage = () => {
  const router = useRouter();
  const {
    onClickTab,
    onSubmitSignIn,
    onSubmitSignUp,
    isSubmitting,
  } = useSignTab(router);

  return {
    onClickTab,
    onSubmitSignIn,
    onSubmitSignUp,
    isSubmitting,
  };
};
